import Styles from '../TitleSelector.module.scss'
import { Button } from 'blaze-ui/Button'
import { Input } from 'almanac-ui/TextInputField/Input'
import { useState } from 'react'

interface AddTitleInputProps {
  onSubmit: (value: string) => void
  onCancel: () => void
}

export const AddTitleInput: React.FC<AddTitleInputProps> = ({ onSubmit, onCancel }) => {
  const [value, setValue] = useState('')

  const handleSubmit = () => {
    if (!value.trim()) return

    onSubmit(value)
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      handleSubmit()
    }
  }

  return (
    <>
      <Input
        name="titleInput"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="Write your own title..."
        autoFocus
        onKeyDown={handleKeyDown}
        variant="grey"
        autoComplete="off"
        isTextarea
        rows={3}
        maxHeight={100}
      />
      <div className={Styles.addTitleButtonContainer}>
        <Button
          variant="tertiary"
          size="md"
          onPress={() => {
            onCancel()
            return false
          }}
          fullWidth
        >
          Cancel
        </Button>
        <Button variant="primary" size="md" onPress={handleSubmit} isDisabled={!value.trim()} fullWidth>
          Add Title
        </Button>
      </div>
    </>
  )
}
